import type { FunnelId } from './config';
import baselineUs from './baseline-us/app.config';
import pricing11 from './big-pricing/11/app.config';
import pricing12 from './big-pricing/12/app.config';
import pricing13 from './big-pricing/13/app.config';
import pricing14 from './big-pricing/14/app.config';
import pricing15 from './big-pricing/15/app.config';
import pricing21 from './big-pricing/21/app.config';
import pricing22 from './big-pricing/22/app.config';
import pricing23 from './big-pricing/23/app.config';
import pricing24 from './big-pricing/24/app.config';
import pricing25 from './big-pricing/25/app.config';
import pricing31 from './big-pricing/31/app.config';
import pricing32 from './big-pricing/32/app.config';
import pricing33 from './big-pricing/33/app.config';
import pricing34 from './big-pricing/34/app.config';
import pricing35 from './big-pricing/35/app.config';
import email from './email/app.config';
import google from './google/app.config';
import retargeting from './retargeting/app.config';
import roundOnly from './round-only/app.config';
import tiktok from './tiktok/app.config';

export const FUNNEL_APP_CONFIGS: Partial<Record<FunnelId, Record<string, unknown>>> = {
  'baseline-us': baselineUs,
  email,
  google,
  retargeting,
  'round-only': roundOnly,
  tiktok,
  '11': pricing11,
  '12': pricing12,
  '13': pricing13,
  '14': pricing14,
  '15': pricing15,
  '21': pricing21,
  '22': pricing22,
  '23': pricing23,
  '24': pricing24,
  '25': pricing25,
  '31': pricing31,
  '32': pricing32,
  '33': pricing33,
  '34': pricing34,
  '35': pricing35,
};

export function resolveFunnelAppConfig(funnelId: FunnelId): Record<string, unknown> {
  return FUNNEL_APP_CONFIGS[funnelId] ?? {};
}
